module.exports = __webpack_public_path__ + "static/media/mk2_pic-1.728eb1d6.jpg";